import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/", { replace: true }); return; }
    const session_id = match[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id });
        setUser(data.user);
        // Clear hash
        window.history.replaceState(null, "", window.location.pathname);
        nav("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        nav("/", { replace: true });
      }
    })();
  }, [location, nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex items-center gap-3 text-slate-600 dark:text-slate-300">
        <Loader2 className="h-5 w-5 animate-spin" /> Signing you in…
      </div>
    </div>
  );
}
